import { useContext } from 'react'
import { HomeContext } from '../../state/home-context'
import { useApiGetProductivity } from '../../../../core/api/home/productivity/useApiGetProductivity'
import WidgetLoading from 'components/common/cards/widget-loading'
import WidgetErrorCard from 'components/common/cards/widget-error-card'
import ProductivityNoContent from './productivity-no-content'
import ProductivityContent from './productivity-content'
import ProductivityIcon from './productivity-icon'
import ProductivityTitle from './productivity-title'
import { isHomeApiEnabled } from 'core/api/home/home-api-utils'

const isDefined = (value: number | null | undefined) => {
  return value != null && value !== 0
}

interface ProductivityProps {
  targetProductivity?: number
}

const Productivity = ({ targetProductivity = null }: ProductivityProps) => {
  const { aggregation, teamId, channel, storeId, team } = useContext(HomeContext)

  const { data, isLoading: isLoadingProductivity } = useApiGetProductivity(
    { storeId, teamId, channel, aggregation },
    isHomeApiEnabled(storeId, teamId, aggregation)
  )

  const hasHours = isDefined(data?.spentHours)
  const hasGmv = isDefined(data?.realizedGmv)
  const hasProductivity = hasHours && hasGmv
  const hasTargetProductivity = isDefined(targetProductivity)

  const productivity = hasProductivity ? data.realizedGmv / data.spentHours : null

  return (
    <>
      {isLoadingProductivity && <WidgetLoading className="mg-productivity-loading" dataTestId="productivity-loading" />}
      {!isLoadingProductivity && !hasGmv && (
        <WidgetErrorCard titleKey="general.homepage.productivity" testId="productivity" />
      )}
      {!isLoadingProductivity && hasGmv && (
        <div data-testid="productivity" className="mg-productivity">
          {hasProductivity && hasTargetProductivity && (
            <ProductivityIcon productivity={productivity} targetProductivity={targetProductivity} />
          )}
          <div className="mg-productivity-content">
            <ProductivityTitle isInstore={channel === 'INSTORE'} isTeam={aggregation === 'TEAM'} team={team} />
            {hasProductivity ? (
              <ProductivityContent
                targetProductivity={targetProductivity}
                productivity={productivity}
                isInstore={channel === 'INSTORE'}
              />
            ) : (
              <ProductivityNoContent />
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default Productivity
